module.exports = "/images/img_signup.png?b8eabb0a0142c1f3d5b1bac0a9d2e7d1";